import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import { FaCcVisa, FaCcMastercard } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-dark container-fluid py-4">
      <Container>
        <Row className="pb-3">
          <Col xs={12} md={3} lg={3}>
            <Nav.Link style={{ color: "white" }} className="footer-link" href="#home">
              <h5>Korisni linkovi</h5>
            </Nav.Link>
            <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              Pretraga čitulja
            </Nav.Link>
            {/* Add more links here */}
            <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
             Adresar groblja
            </Nav.Link> <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              Kontakt
            </Nav.Link> <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              In Memoriam
            </Nav.Link> <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              Korisne informacije
            </Nav.Link>
          </Col>
          <Col xs={12} md={3} lg={3}>
            {/* Add more links here */}

            <Nav.Link style={{ color: "white"}} className="footer-link" href="#link">
             <h5>Politika privatnosti</h5> 
            </Nav.Link> <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              Sakupljanje ličnih podataka
            </Nav.Link> <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              Korišćenje "kolačića"
            </Nav.Link> <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              Zaštita ličnih podataka
            </Nav.Link>
            <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              Intelektualno vlasništvo
            </Nav.Link>

          </Col>
          <Col lg={3} xs={12} md={3}>
            {/* Add more links here */}
            
            <Nav.Link style={{ color: "white" }} className="footer-link" href="#link">
            <h5>Uslovi korišćenja</h5>
            </Nav.Link> <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              Uslovi
            </Nav.Link> <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              Opšti uslovi poslovanja
            </Nav.Link>
            <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              Odgovornosti
            </Nav.Link>
            <Nav.Link style={{ color: "white", textDecoration: "underline" }} className="footer-link" href="#link">
              Odgovornosti
            </Nav.Link>
          </Col>
          <Col xs={12} md={3} lg={3} className="d-flex justify-content-md-end align-items-center">
            <div className="d-flex align-items-center payment">
              <div className="me-3">
                <a style={{ color: "white" }} href="www.nowhere.com">
                  <FaCcVisa size={40} />
                  Visa
                </a>
              </div>
              <div>
                <a style={{ textAlign: "center", color: "white" }} href="nowhere.com">
                  <FaCcMastercard size={40} />
                  MasterCard
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <div className="text-center">
        <small>Copyright &copy; Vijesti 2023</small>
      </div>
    </footer>
  );
}

export default Footer;
